import { BaseIcon, BaseIconProps } from './BaseIcon';

export const VideoGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="videoGrad" {...props}>
    <path d="m22 8-6 4 6 4V8Z" stroke="url(#videoGrad)" />
    <rect width="14" height="12" x="2" y="6" rx="2" ry="2" stroke="url(#videoGrad)" />
  </BaseIcon>
);
